import { BreakpointNames } from '../Breakpoint/Breakpoint';
import { getMaxWidth, getMinWidth, join } from './utils';
var MEDIA_QUERY_PREFIX = '@media only screen and';
function min(breakpoint) {
    return join(MEDIA_QUERY_PREFIX, getMinWidth(breakpoint));
}
function max(breakpoint) {
    var breakpointIndex = BreakpointNames.indexOf(breakpoint);
    if (breakpointIndex === BreakpointNames.length - 1) {
        return join(MEDIA_QUERY_PREFIX, getMinWidth(BreakpointNames[0]));
    }
    return join(MEDIA_QUERY_PREFIX, getMaxWidth(BreakpointNames[breakpointIndex + 1]));
}
function between(minBreakpoint, maxBreakpoint) {
    var maxBreakpointIndex = BreakpointNames.indexOf(maxBreakpoint);
    if (maxBreakpointIndex === BreakpointNames.length - 1) {
        return min(minBreakpoint);
    }
    return join(MEDIA_QUERY_PREFIX, getMinWidth(minBreakpoint), 'and', getMaxWidth(BreakpointNames[maxBreakpointIndex + 1]));
}
function only(breakpoint) {
    return between(breakpoint, breakpoint);
}
export var MediaQuery = {
    min: min,
    max: max,
    between: between,
    only: only,
};
/**
 * Alias for MediaQuery
 */
export var mq = MediaQuery;
//# sourceMappingURL=MediaQuery.js.map